<template>
    <WindowedForm v-model="form" />
</template>
<script>

    import store from "../../store/index.js";
    import ExhibitionService from "../../services/ExhibitionService.js";
    import WindowedForm from "../globalUiElements/WindowedForm.vue";
    import { createForm } from "../../utils/FormUtils.js";
    import { l } from "../../utils/LocalizationUtils.js";


    export default {
        components: {
            WindowedForm
        },
        data() {
            return {
                form: createForm({

                    title: "Create New Exhibition",

                    action: ExhibitionService.insertExhibition,

                    fieldDefs: [
                        {
                            key: "title",
                            type: "Text",
                            label: "Title",
                            required: true
                        },
                        {
                            key: "arTargetXmlFile",
                            type: this.hasSystemAccessRights() ? "Reference" : "Hidden",
                            referenceOf: "media",
                            referenceType: "xml",
                            label: "Vuforia .xml AR target file",
                        },
                        {
                            key: "arTargetDatFile",
                            type: this.hasSystemAccessRights() ? "Reference" : "Hidden",
                            referenceOf: "media",
                            referenceType: "binary",
                            label: "Vuforia .dat AR target file",
                        },
                        {
                            key: "arTargetCopyrightLine",
                            type: "Text",
                            label: "Copyright line for art pieces",
                            localized: true
                        },
                        {
                            key: "textTokens",
                            type: this.hasSystemAccessRights() ? "Array" : "Hidden",
                            label: "Exhibition-specific Text Tokens",
                            entryLabel: "Text token",
                            entryFieldDefs: [
                                {
                                    key: "key",
                                    type: "Text",
                                    label: "Key"
                                },
                                {
                                    key: "translations",
                                    type: "Textarea",
                                    label: "Translations",
                                    localized: true,
                                    richText: true
                                },
                            ],
                            saveEntriesAsObjects: true,
                            value: [],
                        },
                        {
                            key: "appSettings",
                            type: this.hasSystemAccessRights() ? "Array" : "Hidden",
                            label: "Exhibition-specific settings (overrides global App settings)",
                            entryLabel: "Setting",
                            entryFieldDefs: [
                                {
                                    key: "key",
                                    type: "Text",
                                    label: "Key",
                                    value: "",
                                    required: true
                                },
                                {
                                    key: "value",
                                    type: "Textarea",
                                    label: "Value",
                                    value: ""
                                },
                            ],
                            saveEntriesAsObjects: true,
                            value: [],
                        },
                        {
                            key: "defaultPoiDisplayMode",
                            type: "Select",
                            label: "Default POI selection display mode",
                            options: [
                                { text: "Only in AR", value: "AR" },
                                { text: "Only in screenspace", value: "Screenspace" },
                                { text: "Both in AR and screenspace", value: "Both" },
                            ],
                            value: "AR",
                        },
                        {
                            key: "defaultScreenspaceOpeningMode",
                            type: "Select",
                            label: "Default screenspace POI selection opening behavior",
                            options: [
                                { text: "Button in information box", value: "InfoBoxButton" },
                                { text: "Button on AR target", value: "ARButton" },
                                { text: "Buttons both in information box and on AR target", value: "Both" },
                            ],
                            value: "Both",
                        },
                        {
                            key: "outputJSONFile",
                            type: this.hasSystemAccessRights() ? "Checkbox" : "Hidden",
                            label: "Allow generation of App's JSON file",
                            value: true,
                        },
                        {
                            key: "arTargets",
                            type: "Hidden",
                            value: []
                        },
                    ],

                    submitLabel: "Create",

                    submitted: entry => {
                        this.$root.$emit("success", l("Exhibition \"${v.title}\" created.", entry));
                        this.$emit("createdEntry");
                    },

                    cancelled: () => {
                        this.$emit("cancel");
                    }
                })
            }
        },
        methods: {
            hasSystemAccessRights() {
                return store.getters["user/hasSystemAccessRights"];
            },
        },
    }
</script>